export const NTSFieldsToDeepLTranslate = (formData) => ({
  reporter_occupation: `${formData.info.general.reporter_occupation}`,
  location_description: `${formData.info.location.description}`,
  nto_result_comment: `${formData.info.nto_result?.comment}`,
});

export const HAFieldsToDeepLTranslate = (formData) => {
  const mapDescriptions = (evidences, prefix) => evidences?.items?.map((evidence, index) => ({
    [`${prefix}_${index}`]: evidence.description,
  })) || [];

  const mapInformators = (informators, prefix) => informators?.map((informator, index) => ({
    [`${prefix}_position_${index}`]: informator.position,
    [`${prefix}_address_${index}`]: informator.address,
  })) || [];

  const mapInformatorsDescriptions = (informators) => informators?.map((informator, index) => ({
    [`indirect_informator_description_${index}`]: informator,
  })) || [];

  const directEvidencesProperty = mapDescriptions(formData.info.evidences?.direct_evidences, 'direct_evidence_description');
  const indirectEvidencesProperty = mapDescriptions(formData.info.evidences?.indirect_evidences, 'indirect_evidence_description');
  const indirectInformatorsDescriptions = mapInformatorsDescriptions(formData.info.evidences
    ?.indirect_evidences?.informators);
  const informatorInfo = mapInformators(formData.info.informators, 'informator');

  return {
    reporter_occupation: formData.info.general.reporter_occupation,
    nearest_settlement_name: formData.info.location.nearest_settlement_name?.settlement_name,
    hazard_type_description: formData.info.hazard_type?.description,
    ...Object.assign({}, ...directEvidencesProperty, ...indirectEvidencesProperty),
    direct_evidences_main_description: formData.info.evidences?.direct_evidences?.description,
    indirect_evidences_main_description: formData.info.evidences?.indirect_evidences?.description,
    ...Object.assign({}, ...indirectInformatorsDescriptions),
    lm_description: formData.info.lm?.description,
    bm_description: formData.info.bm?.description,
    vegetation_other: formData.info.geographic_and_terrain_description?.vegetation_other,
    relief_other: formData.info.geographic_and_terrain_description?.relief_other,
    current_field_marking_other: formData.info.geographic_and_terrain_description
      ?.current_field_marking_other,
    reasons_and_comments_on_71_72: formData.info.next_landrelease_activity
      ?.reasons_and_comments_on_71_72,
    reasons_and_comments_on_71_72_extended: formData.info.next_landrelease_activity
      ?.reasons_and_comments_on_71_72_extended,
    recommended_clearance_depth: formData.info.next_landrelease_activity
      ?.recommended_clearance_depth,
    recommended_clearance_depth_description: formData.info.next_landrelease_activity
      ?.recommended_clearance_depth_description,
    additional_comments_on_hazard_area: formData.info.next_landrelease_activity
      ?.additional_comments_on_hazard_area,
    additional_comments_on_hazard_area_extended: formData.info.next_landrelease_activity
      ?.additional_comments_on_hazard_area_extended,
    ...Object.assign({}, ...informatorInfo),
  };
};

export const EOREFieldsToDeepLTranslate = (formData) => ({
  reporter_position: `${formData?.info?.general?.reporter_position}`,
  description_of_place_type: `${formData?.info?.session_information?.description_of_place_type}`,
});

export const ClearanceFieldsToDeepLTranslate = (data) => {
  const methods = data?.tcpFormData?.methods || [];
  const mappedMethods = methods?.reduce((acc, method, index) => ({
    ...acc,
    [`method_${index}`]: method?.name,
  }), {});

  const links = data?.gisLinks || [];
  const mappedLinks = links?.reduce((acc, linkObj, index) => {
    const key = Object.keys(linkObj)[0];
    if (key && key !== 'turn_points') {
      return { ...acc, [`file_${index}`]: key };
    }
    return acc;
  }, {});

  return { ...mappedMethods, ...mappedLinks };
};

export const DailyFieldsToDeepLTranslate = (formData) => {
  const fields = {};
  if (formData?.info?.dms?.reporter_position) {
    fields.reporter_position_daily = formData.info.dms.reporter_position;
  }
  if (formData?.info?.dms?.remarks) {
    fields.dms_remarks_daily = formData.info.dms.remarks;
  }
  if (formData?.info?.field_work?.remarks !== undefined && formData?.info?.field_work?.remarks !== null && formData?.info?.field_work?.remarks !== '-') {
    fields.field_work_remarks = `${formData.info.field_work.remarks}`;
  }
  if (formData?.info?.hand_over_block?.remarks !== undefined && formData?.info?.hand_over_block?.remarks !== null) {
    fields.hand_over_remarks = formData.info.hand_over_block.remarks;
  }
  if (formData?.info?.marking?.remarks) {
    fields.marking_remarks = formData.info.marking.remarks;
  }
  const categories = formData?.info?.eo_found_categories || {};
  Object.keys(categories).forEach((catKey) => {
    categories[catKey]?.evidences?.forEach((evi, idx) => {
      const eoName = evi?.name || evi?.item;
      if (eoName) {
        fields[`eo_name_${catKey}_${idx}`] = eoName;
      }
    });
  });
  formData?.info?.hand_over_block?.files?.forEach((file, idx) => {
    if (file?.name) {
      fields[`hand_over_file_${idx}`] = file.name;
    }
  });
  formData?.info?.marking?.files?.forEach((file, idx) => {
    if (file?.name) {
      fields[`mark_file_${idx}`] = file.name;
    }
  });
  return fields;
};

export const WeeklyFieldsToDeepLTranslate = (formData) => {
  const fields = {};
  if (formData?.info?.dms?.reporter_position) {
    fields.reporter_position_daily = formData.info.dms.reporter_position;
  }
  if (formData?.info?.dms?.remarks) {
    fields.dms_remarks_daily = formData.info.dms.remarks;
  }
  if (formData?.info?.field_work?.remarks) {
    fields.field_work_remarks = formData.info.field_work.remarks;
  }
  const handOverBlocksArray = Array.isArray(formData?.info?.hand_over_block)
    ? formData.info.hand_over_block
    : formData?.info?.hand_over_block ? [formData.info.hand_over_block] : [];

  if (handOverBlocksArray.length) {
    const firstBlock = handOverBlocksArray.find((b) => b);
    if (firstBlock?.remarks && firstBlock.remarks !== 'Коментарі' && firstBlock.remarks !== '-') {
      fields.hand_over_remarks = firstBlock.remarks;
    }

    let fileCounter = 0;
    handOverBlocksArray.forEach((block) => {
      block?.files?.forEach((file) => {
        if (file?.name) {
          fields[`hand_over_file_${fileCounter}`] = file.name;
          fileCounter += 1;
        }
      });
    });
  }
  const categories = formData?.info?.eo_found_categories || {};
  Object.keys(categories).forEach((catKey) => {
    categories[catKey]?.links?.forEach((link, idx) => {
      if (link?.name) {
        fields[`eo_file_${catKey}_${idx}`] = link.name;
      }
    });
  });
  return fields;
};
